module.exports = __webpack_public_path__ + "img/02 - Condominio_das_Americas_EspacoGourmet.cb0d723b.jpg";